import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  IdNameModel,
  ListRequestOfBaseFilter,
} from "services/KnowfullyAdminClient";

type SelectOrganizationTypeProps = Omit<
  AutocompleteWithQueryProps<IdNameModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectOrganizationType = (props: SelectOrganizationTypeProps) => {
  const { formatMessage: t } = useIntl();
  const { organizationService } = useGlobalContext();

  const fetchedData = useQuery(["getOrganizationTypes"], () =>
    organizationService.getOrganizationTypes(
      ListRequestOfBaseFilter.fromJS({
        sortField: "name",
      })
    )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedData}
      failMessage={t({ id: "fetchError" })}
    />
  );
};

export default SelectOrganizationType;
